module.exports = __webpack_public_path__ + "static/media/ventfiltersftc.9c895796.png";